"use strict";function downloadFile$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.downloadFile$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.util.downloadFile";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.pc]={vs:"2.5.0"},_a)),exports.downloadFile$=downloadFile$,exports.default=downloadFile$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/util/downloadFile.js
// module id = 1007
// module chunks = 106